import {
  MutationCache,
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import { toast, Toaster } from "sonner";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { router } from "./routes";
import { ThemeProvider } from "./stores/theme-provider";
import { AuthProvider } from "./stores/auth-provider";
import { getErrorMessage } from "./api/client";

const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID || "";

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      toast.error(getErrorMessage(error));
    },
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      toast.error(getErrorMessage(error));
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60 * 1000,
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
});

export function App() {
  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <RouterProvider router={router} />
          </AuthProvider>
          <Toaster
            position="top-right"
            richColors
            toastOptions={{
              classNames: {
                toast:
                  "font-sans rounded-card border-border bg-surface text-foreground shadow-dropdown",
                title: "text-sm font-semibold text-foreground",
                description: "text-sm text-foreground-secondary",
                actionButton: "bg-primary text-foreground-on-primary",
                cancelButton: "bg-muted text-foreground-muted",
                success: "border-success/30 bg-success-light text-success-text",
                error: "border-danger/30 bg-danger-light text-danger-text",
                warning: "border-warning/30 bg-warning-light text-warning-text",
                info: "border-info/30 bg-info-light text-info-text",
              },
            }}
          />
        </QueryClientProvider>
      </ThemeProvider>
    </GoogleOAuthProvider>
  );
}
